import { writeCookie, getCookie, deleteCookie } from "../../features/campaign";

export interface PendingConversion {
  submissionId: string | null;
  className: string;
  classId: string;
  selectionType: string;
  funnelType: string;
  ghlContactId: string | null;
  timestamp: number;
}

const COOKIE_NAME = "ryb_pending_conversion";
const TTL_MS = 30 * 60 * 1000; // 30 minutes

export function setPendingConversion(
  data: Omit<PendingConversion, "timestamp">
): void {
  const payload: PendingConversion = {
    ...data,
    timestamp: Date.now(),
  };
  writeCookie(COOKIE_NAME, btoa(unescape(encodeURIComponent(JSON.stringify(payload)))), 1);
}

export function getPendingConversion(): PendingConversion | null {
  const raw = getCookie(COOKIE_NAME);
  if (!raw) return null;
  try {
    const data: PendingConversion = JSON.parse(decodeURIComponent(escape(atob(raw))));
    if (Date.now() - data.timestamp > TTL_MS) {
      clearPendingConversion();
      return null;
    }
    return data;
  } catch {
    clearPendingConversion();
    return null;
  }
}

export function clearPendingConversion(): void {
  deleteCookie(COOKIE_NAME);
}
